<!--自动控制-->
<template>
  <div>
    <a-card class="all-card-style ">
      <div >
        <a-spin :spinning="spinning">
          <a-table :columns="columns" :data-source="this.deviceData.services">
                <span slot="action" slot-scope="text, record">
                <a @click="showModal('参数配置',record)">查询配置</a>
            </span>
          </a-table>
        </a-spin>
      </div>
    </a-card>
    <!--配置任务弹出框-->
    <a-modal v-model="EditModalVisible" :title="formtitle" @ok="AutoControl" @cancel="AutoCancel" :maskClosable="false" ok-text="确认" cancel-text="取消">
      <a-spin :spinning="modalspinning">
        <a-form-model ref="deviceData" :model="deviceData" :label-col="{ span: 10 }" :wrapper-col="{ span: 12 }">
          <a-form-model-item v-for="(item,index) in deviceData.service" :key="item.identifier" :label="item.name">

            <a-radio-group v-if="index==0" v-model="item.dataValue"  >
              <a-radio-button v-for="m in controlOptions"  :value="m.value">{{m.name}}</a-radio-button>
            </a-radio-group>
            <a-select v-else-if="item.identifier=='CorrSensorId'" v-model="item.dataValue"  >

              <a-select-option v-for="(item,index) in proSelectItems" :key="index" :value="item.key">
                {{item.value}}
              </a-select-option>
            </a-select>
            <a-select v-else-if="item.identifier=='CorrTopCtrlId'" v-model="item.dataValue"  >

              <a-select-option v-for="(item,index) in prowSelectItems" :key="index" :value="item.key">
                {{item.value}}
              </a-select-option>
            </a-select>
            <a-select v-else-if="item.identifier=='CorrBottomCtrlId'" v-model="item.dataValue"  >

              <a-select-option v-for="(item,index) in prowSelectItems" :key="index" :value="item.key">
                {{item.value}}
              </a-select-option>
            </a-select>

            <a-input v-else type="text" autocomplete="off" v-model="item.dataValue"/>
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
  import TitleCard from '@/components/TitleCard.vue'
  import { Chart } from '@antv/g2';
  import { _getDeviceServiceData } from '@/common/request.js'

  const columns = [
    // {
    //   title: '任务名称',
    //   dataIndex: 'name',
    //   key: 'name',
    // },
    {
      title: '服务名称',
      dataIndex: 'serviceName',
      key: 'serviceName',
    },
    {
      title: '标识符',
      dataIndex: 'identifier',
      key: 'identifier',
    },
    {
      title: '是否启用',
      dataIndex: 'Enable',
      key: 'Enable',
    },
    {
      title: '操作',
      key: 'action',
      scopedSlots: { customRender: 'action' },
    },
  ];



  export default {
    name: 'autoControlList',
    components: {

    },
    mounted() {

    },
    data() {
      return {
        form: this.$form.createForm(this),
        columns,
        data:[],
        controlOptions:[{value:"1",name:'启用'}, {value:"0",name:'未启用'}],
        EditModalVisible:false,
        formtitle:'',
        startDate:'1900-01-01',
        proSelectItems:[],
        prowSelectItems:[],
        deviceData:{
          queryInfo:{
            productkey:"",
            devicename:"",
            identifier:"",
            startDate:'1900-01-01',
            limit:1
          },
          queryInfoList:{
            productkey:"",
            devicename:"",
            identifier:"",
            startDate:'',
            endDate:'',
            page:0,
            limit:1
          },
          devices:{},
          proDataTime:"",
          services:[],
          service:[],
          timer: '',//定时器
          timerList:''
        },
        invokeDeviceServiceParam:{
          productKey:"",
          deviceName:"",
          IotId:"",
          identifier:"",
          Param:{}
        },
        spinning:false,
        modalspinning:false
      }
    },
    async created(){
      this.startDate=this.utils.getDate()
      this.IotId=this.$route.query.IotId



      let res = await this.$http.post('WLWDevice/List', {
        sceneId: this.$store.getters.SCene.ID  ,cSystemCode:'节水灌溉',
        cEntID:this.$store.getters.User.enterprise.ID
      })
      var device=res.data.obj.list;
      device=device.filter(x=>x.IotId==this.IotId)[0]
      if(device!=null) this.deviceData.devices=device

      this.deviceData.queryInfo.productkey=this.deviceData.devices.ProductKey
      this.deviceData.queryInfo.devicename=this.deviceData.devices.DeviceName
      this.deviceData.queryInfoList.productkey=this.deviceData.devices.ProductKey
      this.deviceData.queryInfoList.devicename=this.deviceData.devices.DeviceName
      this.invokeDeviceServiceParam.productKey=this.deviceData.devices.ProductKey
      this.invokeDeviceServiceParam.deviceName=this.deviceData.devices.DeviceName

      var ThingModel=this.$store.getters.ThingModels.filter(x=>x.productKey==this.deviceData.devices.ProductKey)[0]
      if(ThingModel!=null) {
        this.deviceData.services=this.utils.deepClone(ThingModel.services)
        this.deviceData.propertiesR=this.utils.deepClone(ThingModel.propertiesR)
        this.deviceData.propertiesW=this.utils.deepClone(ThingModel.propertiesW)
        this.deviceData.events=this.utils.deepClone(ThingModel.events)

        this.deviceData.propertiesR.forEach(element=>{
          var item={
            key:element.identifier,
            value:element.name
          }
          this.proSelectItems.push(item)
        })
        this.deviceData.propertiesW.forEach(element=>{
          var item={
            key:element.identifier,
            value:element.name
          }
          this.prowSelectItems.push(item)
        })

        await this.getServicesDataList()
      }

    },
    methods:{
      async getServicesDataList(){
        var res =await _getDeviceServiceData(this,this.deviceData.queryInfoList)
        console.log(res)
        if(res !=null ){

          var data=res.obj.list
          if(data!=null && data.length>0)
          {
            data.forEach(element=>{
              var enable=element.datas["Enable"]
              if(enable!=null){
                var item= this.deviceData.services.filter(x=>element.topic.indexOf('/'+x.identifier+'_reply')>0)
                if(item!=null && item.length>0)
                {
                  this.$set(item[0],"Enable",enable==1?'启用':'未启用')
                }

              }
            })
          }
        }
      },
      async showModal(txt,record){
        this.spinning=true
        let now=this.utils.getDateTime()
        let that=this
        that.formtitle=record.serviceName+"-"+ txt;
        if(record!=null) {
          // that.deviceData.queryInfo.startDate=now
          that.deviceData.queryInfo.identifier=record.identifier
          that.invokeDeviceServiceParam.identifier=record.identifier
          const {data:res} = await this.$http.post('WLWDevice/QueryDeviceService',that.deviceData.queryInfo)

          if(true){
            const {data:res2} = await this.$http.post('WLWDevice/QueryDeviceService',that.deviceData.queryInfo)


            var datas=[]
            if(res2.obj.list!=null && res2.obj.list.length>0){
              datas=res2.obj.list[0].datas
            }
            var service=that.deviceData.services.filter(x=>x.identifier ==record.identifier)
            if(service!=null && service.length>0){
              that.deviceData.service=service[0].inputParams

            }
            this.deviceData.service.forEach(element => {
              if(datas[element.identifier]!=null){

                this.$set(element,"dataValue",datas[element.identifier])
              }
              else{
                this.$set(element,"dataValue","")
              }
            })
            if (res2.code=="200"){
              that.$message.success(res2.message)
            }else{
              that.$message.success('已查询到启动状态，请再次点击查询!');
            }



            that.EditModalVisible=true
          }

        }
        this.spinning=false
      },
      async AutoControl(){
        this.modalspinning=true
        var that = this
        var param=''
        this.deviceData.service.forEach(element => {
          switch(element.dataType){
            case "INT":
            case "FLOAT":
            case "DOUBLE":
              param+='"'+element.identifier+'":'+element.dataValue+','
              break
            default:
              param+='"'+element.identifier+'":"'+element.dataValue+'",'
              break
          }

        })
        param=param.substring(0,param.length-1)

        that.invokeDeviceServiceParam.Param='{'+param+'}'
        const {data:res} = await this.$http.post('WLWDevice/InvokeDeviceService',this.invokeDeviceServiceParam)
        if(res.code=="200"){
          this.modalspinning=false
          this.EditModalVisible=false
          await this.getServicesDataList()
          this.$message.success(res.message)
        }
        else{
          this.modalspinning=false
          this.$message.error(res.message)
        }
      },
      AutoCancel(){
        this.EditModalVisible=false
      }
    },


  }
</script>



<style>
  @import "../equipmentDetailsStyle.css";
</style>


